export default __webpack_public_path__ + "static/media/appfog.a584fea5.svg";